import createReducer from 'legacy/src/shared/util/createReducer';
import {
  downloadAllAnswerSheets,
  downloadIndividualAnswerSheet,
  downloadGeneratedAnswerSheet,
  generateAnswerSheets,
  generateAnswerSheetsPreview,
  initiateDownloadForUser,
  resetAnswerSheetsPreview,
} from 'legacy/src/actions/paperscorer';

const initialState = {
  allAnswerSheetUrls: [],
  answerSheetsPreviewUrl: '',
  answerSheetsUrl: {},
  error: null,
  individualAnswerSheetUrl: '',
  loadingIndividualAnswerSheet: false,
  loadingAllAnswerSheets: false,
  loadingAnswerSheetsPreview: false,
  loadingGeneratedAnswersheet: false,
  generatedAnswersheetUrl: '',
};

const reducer = createReducer(initialState, {
  [generateAnswerSheets.SUCCESS]: (state, { payload }) => ({
    ...state,
    answerSheetsUrl: payload,
  }),
  [resetAnswerSheetsPreview.TRIGGER]: (state) => ({
    ...state,
    answerSheetsPreviewUrl: initialState.answerSheetsPreviewUrl,
  }),
  [generateAnswerSheetsPreview.TRIGGER]: (state) => ({
    ...state,
    loadingAnswerSheetsPreview: true,
  }),
  [generateAnswerSheetsPreview.SUCCESS]: (state, { payload }) => ({
    ...state,
    answerSheetsPreviewUrl: payload,
    loadingAnswerSheetsPreview: false,
  }),
  [generateAnswerSheetsPreview.FAILURE]: (state) => ({
    ...state,
    loadingAnswerSheetsPreview: false,
  }),
  [downloadAllAnswerSheets.TRIGGER]: (state) => ({
    ...state,
    loadingAllAnswerSheets: true,
  }),
  [downloadAllAnswerSheets.SUCCESS]: (state, { payload }) => ({
    ...state,
    allAnswerSheetUrls: payload.form,
    loadingAllAnswerSheets: false,
  }),
  [downloadAllAnswerSheets.FAILURE]: (state, { payload }) => ({
    ...state,
    error: payload,
    loadingAllAnswerSheets: false,
  }),
  [downloadIndividualAnswerSheet.TRIGGER]: (state) => ({
    ...state,
    loadingIndividualAnswerSheet: true,
  }),
  [downloadIndividualAnswerSheet.SUCCESS]: (state, { payload }) => ({
    ...state,
    individualAnswerSheetUrl: payload.form,
    loadingIndividualAnswerSheet: false,
  }),
  [downloadIndividualAnswerSheet.FAILURE]: (state, { payload }) => ({
    ...state,
    error: payload,
    loadingIndividualAnswerSheet: false,
  }),
  [downloadGeneratedAnswerSheet.TRIGGER]: (state) => ({
    ...state,
    loadingGeneratedAnswersheet: true,
  }),
  [downloadGeneratedAnswerSheet.SUCCESS]: (state, { payload }) => ({
    ...state,
    generatedAnswersheetUrl: payload,
  }),
  [downloadGeneratedAnswerSheet.FAILURE]: (state, { payload }) => ({
    ...state,
    error: payload,
    loadingGeneratedAnswersheet: false,
  }),
  [initiateDownloadForUser.SUCCESS]: (state) => ({
    ...state,
    loadingGeneratedAnswersheet: false,
  }),
  [initiateDownloadForUser.FAILURE]: (state, { payload }) => ({
    ...state,
    error: payload,
    loadingGeneratedAnswersheet: false,
  }),
});

export default reducer;
